import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API || '';

function getSuggestions(pathname) {
  const p = pathname.toLowerCase();
  const suggestions = [];

  if (p.includes('vaideekam') || p.includes('vaitheekam')) {
    suggestions.push({ path: '/vaideekam', label: 'வைதீகம் / Vaideekam' });
  }
  if (p.includes('panjangam') || p.includes('panchangam')) {
    suggestions.push({ path: '/panchangam/panchangam', label: 'பஞ்சாங்கம் / Panchangam' });
  }
  if (p.includes('divyadesams') || p.includes('divyadesam')) {
    suggestions.push({ path: '/divyadesams', label: '108 திவ்யதேசங்கள் / Divyadesams' });
  }
  if (p.includes('blog')) {
    suggestions.push({ path: '/blog', label: 'தொகுப்புகள் / Blog' });
  }
  if (p.includes('shradham') || p.includes('shradhdha')) {
    suggestions.push({ path: '/panchangam/shradhdha-thithi', label: 'ஶ்ராத்த திதி / Shradhdha Thithi' });
  }
  if (p.includes('theetu') || p.includes('theettu')) {
    suggestions.push({ path: '/panchangam/theetu', label: 'தீட்டு / Theetu' });
  }
  if (p.includes('forum')) {
    suggestions.push({ path: '/qa', label: 'கேள்வி பதில் / Q&A' });
  }
  if (p.includes('download')) {
    suggestions.push({ path: '/shop', label: 'பொருட்கள் / Shop' });
  }
  if (p.includes('calendar') || p.includes('event')) {
    suggestions.push({ path: '/panchangam/calendar', label: 'நாள்காட்டி / Calendar' });
  }

  if (suggestions.length === 0) {
    suggestions.push({ path: '/', label: 'முகப்பு / Home' });
  }

  return suggestions;
}

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#f0f5e8',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    background: 'linear-gradient(135deg, #090b72, #1a237e)',
    color: '#fff',
    padding: '40px 20px 32px',
    textAlign: 'center',
  },
  headerEmoji: {
    fontSize: '48px',
    display: 'block',
    marginBottom: '12px',
  },
  headerTitle: {
    fontSize: '28px',
    fontWeight: '700',
    margin: '0 0 8px',
    lineHeight: '1.3',
  },
  headerSubtitle: {
    fontSize: '16px',
    opacity: 0.85,
    margin: 0,
    fontWeight: '400',
    lineHeight: '1.5',
  },
  container: {
    maxWidth: '680px',
    margin: '0 auto',
    padding: '24px 16px 60px',
  },
  card: {
    backgroundColor: '#fffef0',
    borderRadius: '16px',
    padding: '28px 24px',
    marginBottom: '24px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    border: '1px solid #e8e5d0',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1b5e20',
    marginTop: 0,
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  urlBox: {
    backgroundColor: '#fff3e0',
    border: '1px solid #ffe0b2',
    borderRadius: '8px',
    padding: '12px 16px',
    fontFamily: 'monospace',
    fontSize: '14px',
    color: '#e65100',
    wordBreak: 'break-all',
    marginBottom: '4px',
  },
  urlNote: {
    fontSize: '13px',
    color: '#888',
    marginTop: '8px',
    marginBottom: 0,
  },
  suggestionList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  suggestionItem: {
    marginBottom: '10px',
  },
  suggestionLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 18px',
    backgroundColor: '#e8f5e9',
    color: '#1b5e20',
    borderRadius: '8px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '15px',
    transition: 'all 0.2s',
    border: '1px solid #c8e6c9',
  },
  formGroup: {
    marginBottom: '18px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '6px',
  },
  labelOptional: {
    fontWeight: '400',
    color: '#999',
    fontSize: '13px',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.2s',
  },
  textarea: {
    width: '100%',
    padding: '10px 14px',
    fontSize: '15px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    minHeight: '120px',
    resize: 'vertical',
    outline: 'none',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    transition: 'border-color 0.2s',
  },
  submitBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: '700',
    color: '#fff',
    backgroundColor: '#e65100',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  },
  submitBtnDisabled: {
    backgroundColor: '#bbb',
    cursor: 'not-allowed',
  },
  successBox: {
    backgroundColor: '#e8f5e9',
    border: '1px solid #a5d6a7',
    borderRadius: '12px',
    padding: '24px',
    textAlign: 'center',
  },
  successEmoji: {
    fontSize: '40px',
    display: 'block',
    marginBottom: '12px',
  },
  successTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1b5e20',
    margin: '0 0 8px',
  },
  successText: {
    fontSize: '15px',
    color: '#555',
    margin: 0,
    lineHeight: '1.6',
  },
  errorText: {
    color: '#c62828',
    fontSize: '14px',
    marginTop: '8px',
  },
  homeLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: '20px',
    color: '#1a237e',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '15px',
  },
  footer: {
    textAlign: 'center',
    padding: '20px',
    fontSize: '14px',
    color: '#888',
  },
};

export default function ContentRequestPage() {
  const location = useLocation();
  const pathname = location.pathname;
  const suggestions = getSuggestions(pathname);

  const [form, setForm] = useState({ email: '', name: '', description: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.email.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/api/content-request/submit`, {
        email: form.email.trim(),
        name: form.name.trim(),
        requested_url: pathname,
        description: form.description.trim(),
      });
      setSubmitted(true);
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          'Something went wrong. Please try again later.'
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <span style={styles.headerEmoji}>🙏</span>
        <h1 style={styles.headerTitle}>
          நீங்கள் தேடிய பக்கம் இடம் மாறியிருக்கலாம்
        </h1>
        <p style={styles.headerSubtitle}>
          The page you were looking for may have moved to a new location.
          <br />
          Don't worry — we'll help you find what you need!
        </p>
      </div>

      <div style={styles.container}>
        {/* Attempted URL */}
        <div style={styles.card}>
          <h2 style={styles.sectionTitle}>
            <span>🔍</span> You tried to visit
          </h2>
          <div style={styles.urlBox}>{pathname}</div>
          <p style={styles.urlNote}>
            This page may have been moved or renamed during our recent site
            update.
          </p>
        </div>

        {/* Suggestions */}
        <div style={styles.card}>
          <h2 style={styles.sectionTitle}>
            <span>✨</span> Suggested pages / பரிந்துரைகள்
          </h2>
          <p
            style={{
              fontSize: '14px',
              color: '#666',
              margin: '0 0 16px',
              lineHeight: '1.5',
            }}
          >
            Based on the URL you visited, you might be looking for one of these:
          </p>
          <ul style={styles.suggestionList}>
            {suggestions.map((s) => (
              <li key={s.path} style={styles.suggestionItem}>
                <Link
                  to={s.path}
                  style={styles.suggestionLink}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#c8e6c9';
                    e.currentTarget.style.transform = 'translateX(4px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#e8f5e9';
                    e.currentTarget.style.transform = 'none';
                  }}
                >
                  <span>→</span> {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Content Request Form */}
        <div style={styles.card}>
          <h2 style={styles.sectionTitle}>
            <span>📝</span> Can't find what you need? / உள்ளடக்கம் கோரிக்கை
          </h2>

          {submitted ? (
            <div style={styles.successBox}>
              <span style={styles.successEmoji}>✅</span>
              <h3 style={styles.successTitle}>
                நன்றி! Thank you for your request!
              </h3>
              <p style={styles.successText}>
                We've received your content request and will review it shortly.
                <br />
                உங்கள் கோரிக்கை பெறப்பட்டது. விரைவில் பதிலளிப்போம்.
              </p>
              <Link
                to="/"
                style={styles.homeLink}
                onMouseEnter={(e) => {
                  e.currentTarget.style.textDecoration = 'underline';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.textDecoration = 'none';
                }}
              >
                🏠 Go to Home / முகப்புக்கு செல்ல
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p
                style={{
                  fontSize: '14px',
                  color: '#666',
                  margin: '0 0 20px',
                  lineHeight: '1.5',
                }}
              >
                Let us know what you were looking for and we'll try to help you
                find it or create it.
              </p>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="cr-email">
                  Email <span style={{ color: '#c62828' }}>*</span>
                </label>
                <input
                  id="cr-email"
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="your@email.com"
                  required
                  style={styles.input}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#1b5e20';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#ccc';
                  }}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="cr-name">
                  Name{' '}
                  <span style={styles.labelOptional}>(optional / விருப்பம்)</span>
                </label>
                <input
                  id="cr-name"
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Your name / உங்கள் பெயர்"
                  style={styles.input}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#1b5e20';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#ccc';
                  }}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label} htmlFor="cr-description">
                  Description / விளக்கம்
                </label>
                <textarea
                  id="cr-description"
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  placeholder="Please describe what content you are looking for (English or Tamil) / நீங்கள் தேடும் உள்ளடக்கத்தை விவரிக்கவும்"
                  style={styles.textarea}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#1b5e20';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#ccc';
                  }}
                />
              </div>

              {error && <p style={styles.errorText}>{error}</p>}

              <button
                type="submit"
                disabled={submitting}
                style={{
                  ...styles.submitBtn,
                  ...(submitting ? styles.submitBtnDisabled : {}),
                }}
                onMouseEnter={(e) => {
                  if (!submitting) e.currentTarget.style.backgroundColor = '#bf360c';
                }}
                onMouseLeave={(e) => {
                  if (!submitting) e.currentTarget.style.backgroundColor = '#e65100';
                }}
              >
                {submitting ? '⏳ Submitting...' : '📩 Submit Request / சமர்ப்பிக்க'}
              </button>
            </form>
          )}
        </div>

        {/* Footer help */}
        <div style={styles.footer}>
          <p style={{ margin: 0 }}>
            🙏 அஹோபிலம்.com — Encyclopaedia of encyclopaedias for encyclopaedic encyclopaedias
          </p>
        </div>
      </div>
    </div>
  );
}
